window['CallToActionSticker'] = () => {
  return {
    show: false,
    mounted() {
      const mainContent = document.getElementById('MainContent');
      const revealSection = mainContent?.querySelector(
        '[id$="__1655418029152b9f11"]'
      );

      if (!revealSection) return;

      const observer = new window.IntersectionObserver(
        ([entry]) => {
          // Keep the CTA hidden while this section is below or inside the
          // viewport. Reveal it only after the section's bottom scrolls past
          // the top edge.
          this.show = entry.boundingClientRect.bottom <= 0;
        },
        {
          root: null,
          threshold: 0,
        }
      );
      observer.observe(revealSection);
    },
  };
};
